import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      dialog: false
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedBasket'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_SELECTED_BASKET()
  },
  methods: {
    ...mapActions([
      'actionRemoveBasket'
    ]),
    ...mapMutations([
      'SET_SELECTED_BASKET'
    ]),
    confirmRemoveBasket () {
      this.SET_SELECTED_BASKET()

      this.closeModal()
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    deleteBasket () {
      this.isLoading = true

      this.actionRemoveBasket(this.getterSelectedBasket.idProviderFlow)
        .then(() => {
          this.confirmRemoveBasket()

          this.sendToast({
            text: 'Cesta excluída com sucesso',
            type: 'success'
          })
        })
        .catch((e) => {
          this.closeModal()

          if (e && e.data && e.data.code) {
            switch (e.data.code) {
              case 'DELETE_PROVIDERFLOW':
                this.sendToast({
                  text: 'Não é possível excluir esta cesta, foram feitas consultas a partir dela.',
                  type: 'warning'
                })
                break
              default:
                this.sendToast({
                  text: 'Ocorreu um erro desconhecido ao excluir a cesta, verifique com o suporte!',
                  type: 'danger'
                })
            }
          } else {
            this.sendToast({
              text: 'Ocorreu um erro ao excluir a cesta, tente novamente mais tarde!',
              type: 'danger'
            })
          }
        })
    }
  }
}
